import { a as b } from "./js.cookie-OLEfuq_g.js";
import { getContact as Ie } from "@accor/customer-api/cloud";
const A = {
  b2bbookingcontext: "",
  category: "",
  clienttype: "B2C",
  countrycurrencycode: "",
  hotelcurrencycode: "",
  hotelbrandcode: "",
  hotelbrandname: "",
  hotelcitycode: "",
  hotelcityname: "",
  hotelcode: "",
  hotelcountrycode: "",
  hotelcountryname: "",
  hotelgssrating: "",
  hotelname: "",
  hoteltripadvisorrating: "",
  mainstepindicator: 0,
  offercode: "",
  pagetype: "",
  partnerdeduplication: 0,
  partners_name: "",
  partners_type: "",
  roomcode: "",
  searchcriteriaarrivaldate: "",
  searchcriteriacitycode: "",
  searchcriteriacityname: "",
  searchcriteriacountrycode: "",
  searchcriteriacountryname: "",
  searchcriteriadeparturedate: "",
  searchcriteriadestination: "",
  searchcriteriahotelratingclass: "",
  searchcriteriauseb2bcode: !1,
  searchresultsdetails: [],
  sub_category_level1: "",
  sub_category_level2: "",
  sub_category_level3: "",
  sub_category_level4: "",
  transactionId: "",
  ui_snu: "",
  virtual_page_path: ""
}, g = {
  userId: "",
  uilogged: !1,
  uicity: "",
  uicountry: "",
  uiallmember: "not logged",
  uiloyaltypoints: "",
  newsletteroptin: !1,
  clienttype: "B2C",
  uiemailsha256: "",
  loyaltycardtypes: "",
  uisnu_activation: "not connected",
  uistayplus_activation: "not connected"
}, ze = {
  event: "GAevent",
  eventAction: "",
  eventCategory: "",
  eventLabel: ""
}, Ne = "ORM_ALL", Me = "_LOGIN", ae = "data-pagename", Je = "data-nopush", ne = "TS_AH", We = "trckCookie", F = "", Oe = "gacid", $e = ".accor.com", re = "outside-client", Ze = {
  partner_id: null,
  hmGUID: /[a-zA-Z0-9]{22}/gm,
  qt_tracking_id: null,
  advertiser_id: /[0-9]*/gm,
  trvReference: /[0-9a-f]{8}[0-9a-f]{4}[0-5][0-9a-f]{3}[089ab][0-9a-f]{3}[0-9a-f]{12}/gm,
  locale: /[A-Z]{2}/gm,
  refId: /[a-zA-Z0-9-]{36}/gm,
  kayakclickid: /[a-zA-Z0-9-_$~=]{100}/gm
}, he = (e, t) => {
}, O = (...e) => b.get(...e);
var Pe = [
  {
    brandName: "businesstravel",
    brandCode: "BUS",
    urlPattern: /businesstravel\.accor\.com/,
    code: "ah",
    gtmId: "GTM-TKQN7D"
  },
  {
    brandName: "hotelf1",
    brandCode: "HOF",
    urlPattern: /hotelf1\.accor\.com/,
    code: "for",
    gtmId: "GTM-TKQN7D"
  },
  {
    brandName: "ibis",
    brandCode: "IBI",
    urlPattern: /ibis\.accor\.com/,
    code: "ibi",
    gtmId: "GTM-TKQN7D"
  },
  {
    brandName: "meetings",
    brandCode: "MEE",
    urlPattern: /meetings\.accor\.com/,
    code: "ah",
    gtmId: "GTM-TKQN7D"
  },
  {
    brandName: "mercure",
    brandCode: "MER",
    urlPattern: /mercure\.accor\.com/,
    code: "mer",
    gtmId: "GTM-TKQN7D"
  },
  {
    brandName: "mgallery",
    brandCode: "MGA",
    urlPattern: /mgallery\.accor\.com/,
    code: "mga",
    gtmId: "GTM-TKQN7D"
  },
  {
    brandName: "novotel",
    brandCode: "NOV",
    urlPattern: /novotel\.accor\.com/,
    code: "for",
    gtmId: "GTM-TKQN7D"
  },
  {
    brandName: "pullman",
    brandCode: "PUL",
    urlPattern: /pullman\.accor\.com/,
    code: "pul",
    gtmId: "GTM-TKQN7D"
  },
  {
    brandName: "sofitel",
    brandCode: "SOF",
    urlPattern: /sofitel\.accor\.com/,
    code: "sof",
    gtmId: "GTM-TKQN7D"
  },
  {
    brandName: "travelpros",
    brandCode: "TRA",
    urlPattern: /travelpros\.accor\.com/,
    code: "ah",
    gtmId: "GTM-TKQN7D"
  },
  {
    brandName: "all",
    brandCode: "ACH",
    urlPattern: /all.accor\.com/,
    code: "ah",
    gtmId: "GTM-TKQN7D"
  },
  {
    brandName: "accorhotels.cn",
    brandCode: "ACN",
    urlPattern: /\.accorhotels\.cn/,
    code: "acn",
    gtmId: "GTM-MQMZNH7"
  },
  {
    brandName: "thesebel",
    brandCode: "SEB",
    urlPattern: /thesebel\.hotelandbook\.com/,
    code: "seb",
    gtmId: "GTM-MG78MFC"
  },
  {
    brandName: "resorts",
    brandCode: "RST",
    urlPattern: /resorts\.accor\.com/,
    code: "rst",
    gtmId: "GTM-TKQN7D"
  }
], Xe = {
  brandName: "all",
  brandCode: "ACH",
  urlPattern: "default",
  code: "ah",
  gtmId: "GTM-TKQN7D"
};
function Ye() {
  for (var e = location.hostname, t = 0; t < Pe.length; t++) {
    var a = Pe[t];
    if (e.match(a.urlPattern))
      return a;
  }
  return Xe;
}
function K() {
  var e = Ye(), t = location.hostname.substring(location.hostname.lastIndexOf(".", location.hostname.lastIndexOf(".") - 1) + 1);
  return Object.assign({}, {
    isMobile: location.hostname.indexOf("m." + t) > -1,
    rootHostname: t
  }, e);
}
function et() {
  var e, t = function(a) {
    return a === "gb" ? "en" : a;
  };
  return e = document.location.href.match(/\/([a-z]{2}(?:-[a-z]{2})?)\//), e ? t(e[1]) : (e = document.documentElement.lang, e || (e = document.getElementsByTagName("html")[0].getAttribute("xml:lang"), e) ? t(e) : "en");
}
function tt(e) {
  var t = !1;
  if (e && typeof e == "string" && e.length > 0) {
    var a = new RegExp(/\.accor\.com/);
    t = a.test(e);
  }
  return t;
}
function at() {
  let e = "staging";
  const t = O("_Hw2h_");
  return t && typeof t == "string" && t.length > 0 && t.match(/\.(evy|elr)\d{1}[a-d]/) && (e = "production"), e;
}
function nt() {
  const e = O("deviceType");
  return e || "";
}
function rt() {
  let e = O("userLocalization");
  return (!e || e == '""') && (e = O("userPrefLocalization")), e || "";
}
function it() {
  let e = "";
  return K().brandName && (e = K().brandName, e = e.toUpperCase()), e;
}
function ot(e) {
  {
    const t = "." + K().rootHostname;
    (void 0)(e, { path: "/", domain: t });
  }
}
function ie() {
  const e = document.referrer;
  let t = "";
  return e == "" ? t = "DIRECT_ACCESS" : tt(e) || (t = "REFERRALS"), t;
}
function oe(e, t) {
  const a = e || {}, n = t || {};
  for (const r in n)
    n[r] && (a[r] = n[r]);
  return a;
}
function ct(e) {
  var n, r, o;
  let t = !1;
  const a = ((o = (r = (n = e == null ? void 0 : e.loyalty) == null ? void 0 : n.subscriptionCards) == null ? void 0 : r.card[0]) == null ? void 0 : o.cardProduct) || null;
  return a && typeof (a == null ? void 0 : a.productLabel) < "u" && ((a == null ? void 0 : a.productLabel) === "ALL PLUS ibis" || (a == null ? void 0 : a.productLabel) === "ALL PLUS Voyageur") && (t = !0), t;
}
function me() {
  return document.body != null && document.body.getAttribute(Je) === "1";
}
function st() {
  return document.body != null && document.body.getAttribute("data-gtmdisabletrackuser") === "1";
}
function Q() {
  const e = O("gtmId");
  return e || "GTM-TKQN7D";
}
function dt() {
  const e = O("UAUID");
  return e || "";
}
function lt() {
  return new RegExp(/^(\/ssr\/|\/store\/)/).test(window.location.pathname);
}
function ut() {
  let e = !1;
  const t = document.querySelector("script[data-disable-auto-trackpage]");
  return t && (e = /^(true|1)$|^$/.test(t.getAttribute("data-disable-auto-trackpage"))), e;
}
function mt() {
  return new Promise((t) => {
    let a = !0;
    ut() && (a = !1), lt() && (a = !1), document.body != null ? (me() ? a = !1 : a &= !0, t(a)) : document.addEventListener("DOMContentLoaded", function() {
      me() ? a = !1 : a &= !0, t(a);
    });
  });
}
function Re(e, t, a) {
  return e && t && a ? e + "-" + t + "-" + a : "";
}
function gt(e) {
  let t = {};
  const a = "." + K().rootHostname, n = "/", r = location.search.substring(1), o = new URLSearchParams(r), u = Object.keys(e).reduce(function(d, i) {
    var c = o.get(i);
    return c && (e[i] !== null ? new RegExp(e[i]).test(c) && (d[i] = c) : d[i] = encodeURIComponent(c)), d;
  }, {});
  for (const d of Object.keys(e)) {
    t[d] = "";
    const i = u[d] || null;
    if (i && typeof i == "string" && i.length > 0)
      (void 0)(d, i, {
        domain: a,
        path: n
      }), t[d] = i;
    else {
      const c = O(d, {
        domain: a,
        path: n
      });
      c && typeof c == "string" && c.length > 0 && (t[d] = c);
    }
  }
  return t;
}
async function je(e) {
  const t = new TextEncoder().encode(e), a = await window.crypto.subtle.digest("SHA-256", t);
  return Array.from(new Uint8Array(a)).map((o) => o.toString(16).padStart(2, "0")).join("");
}
window.dataLayer = window.dataLayer || [];
const M = {
  isNativeJS: !1,
  // Fill DL functions
  fillDatasFromPeriod: function(e, t) {
    if (t.dayInStr && t.monthInStr && t.yearInStr) {
      var a = t.dayInStr, n = t.monthInStr, r = t.yearInStr;
      e.searchcriteriaarrivaldate = Re(a, n, r);
    }
    if (t.dayOutStr && t.monthOutStr && t.yearOutStr) {
      var o = t.dayOutStr, s = t.monthOutStr, u = t.yearOutStr;
      e.searchcriteriadeparturedate = Re(o, s, u);
    }
    e.datefieldempty = e.searchcriteriaarrivaldate == null && e.searchcriteriadeparturedate == null;
  },
  fillDatasFromRoomCriteria: function(e, t) {
    for (var a = 0; a < t.length; a++) {
      var n = null;
      if ((e["searchroomcriteria" + (a + 1)] == null || e["searchroomcriteria" + (a + 1)] == null) && (e["searchroomcriteria" + (a + 1)] = {
        numberadults: 1,
        numberchildren: 0,
        childrenage1: 0,
        childrenage2: 0,
        childrenage3: 0
      }), n = e["searchroomcriteria" + (a + 1)], n.numberadults = t[a].adultNumber, t[a].children) {
        n.numberchildren = t[a].children.length;
        for (var r = t[a].children.length - 1; r >= 0; r--)
          n["childrenage" + (r + 1)] = t[a].children[r].age;
      }
    }
    return e;
  },
  fillDatasFromFidelityCards: function(e, t, a) {
    if (a && a.length > 0)
      for (var n = 0; n < a.length; n++) {
        var r = a[n];
        r && r.type && e.loyaltycardtypes.push(r.type);
      }
    else t && t.type && e.loyaltycardtypes.push(t.type);
    return e;
  }
};
(function(e) {
  if (e && e.registerConfigurationEventTracking)
    return;
  var t = function(i, c, m) {
    var l = {
      event: i.event,
      eventCategory: i.eventCategory,
      eventAction: i.eventAction,
      eventLabel: "label not found"
    };
    return typeof i.eventLabel == "function" ? l.eventLabel = i.eventLabel(c) : l.eventLabel = i.eventLabel, typeof i.eventAction == "function" ? l.eventAction = i.eventAction(c) : l.eventAction = i.eventAction, m && (l.eventCallback = m, l.eventTimeout = 1e3), l;
  }, a = function(i, c) {
    var m = "";
    switch (i.tagName) {
      case "INPUT":
        m = i;
        break;
      case "SELECT":
        m = i;
        break;
      case "A":
        m = i;
        break;
      case "BUTTON":
        m = i;
        break;
      default:
        var l = i.parentElement || i.parentNode;
        do
          if (l.tagName == "A" || l.tagName == "BUTTON") {
            m = l;
            break;
          } else
            l = l.parentElement || l.parentNode;
        while (l.tagName == "A" || l.tagName == "BUTTON");
    }
    return m;
  }, n = function(i, c) {
    var m = c || {}, l = m.tagEvents || [], f = l.length || 0, h = 0, p = a(i.target);
    if (p !== "") {
      var v = p.getAttribute("href") || "", _ = p.getAttribute("target") || "", y = v.length > 0 && p.tagName == "A" && !(_.length > 0 && _.toLowerCase() == "_blank");
      y && i.preventDefault();
    }
    String.prototype.startsWith || (String.prototype.startsWith = function(P, w) {
      return w = w || 0, this.indexOf(P, w) === w;
    });
    var C = function() {
      y && p !== "" && v.length > 0 && (window.location.href = v);
    }, q = function(P) {
      var w = Q();
      P == w && (h++, h == f && C());
    }, I = q, G = window.jQuery3 || window.jQuery || window.$;
    !M.isNativeJS && G && (p = G(p));
    for (var z in l) {
      var J = l[z], W = t(J, p, I);
      r(W);
    }
  }, r = function(i) {
    typeof window.google_tag_manager > "u" ? i.eventCallback(Q()) : window.dataLayer.push(i);
  }, o = function(i, c, m) {
    if (i.length > 0)
      for (let l = 0; l < i.length; l++)
        i[l].classList.add(m), i[l].addEventListener(c.event || "click", (f) => {
          n(f, c);
        });
  };
  function s(i, c, m, l) {
    i.addEventListener(c, function(f) {
      for (var h = i.querySelectorAll(m), p = f.target, v = 0, _ = h.length; v < _; v++)
        for (var y = p, C = h[v]; y && y !== i; ) {
          if (y === C)
            return l.call(C, f);
          y = y.parentNode;
        }
    });
  }
  let u = function(i, c) {
    let m = c.tagEvents;
    if (m && m.length > 0) {
      let l = document.querySelectorAll(i);
      if (l.length > 0)
        if (c.childToBind)
          for (let f = 0; f < l.length; f++) {
            let h = l[f];
            h.classList.add("gaTrackedChild"), s(h, c.event || "click", c.childToBind, (p) => {
              he("callback function on gaTrackedChild for element: " + i + " " + c.childToBind), n(p, c);
            });
          }
        else {
          let f = document.querySelectorAll(i);
          o(f, c, "gaTrackedElement");
        }
    }
  };
  var d = function(i) {
    let c = i.events;
    for (let m in c) {
      const l = c[m];
      u(m, l);
    }
  };
  e.registerConfigurationEventTracking = function(i, c) {
    M.isNativeJS = c || !1, i && d(i);
  };
})(M);
function ft(e) {
  return new Promise((t, a) => {
    ((n, r, o, s, u) => {
      n[s] = n[s] || [], n[s].push({
        "gtm.start": (/* @__PURE__ */ new Date()).getTime(),
        event: "gtm.js"
      });
      let d = !1, i = r.getElementsByTagName(o)[0], c = r.createElement(o), m = "";
      c.id = "gtm-script", c.type = "text/javascript", c.src = "https://www.googletagmanager.com/gtm.js?id=" + u + m, c.async = !0, c.onerror = function(l) {
        console.error("## TagManager - loading script gtm in error", l), a(l);
      }, c.onload = function() {
        !d && (!this.readyState || this.readyState == "complete") && (d = !0, t(u));
      }, i.parentNode.insertBefore(c, i);
    })(window, document, "script", "dataLayer", e);
  });
}
class B {
  constructor(t) {
    this.value = t;
  }
  toString() {
    return "State " + this.value;
  }
  equals(t) {
    return this.value == t.value;
  }
}
const T = {
  INIT: new B(1),
  LOADING: new B(2),
  LOADED: new B(3),
  ERROR: new B(0)
};
class pt {
  constructor() {
    this.id = "LDR-" + (/* @__PURE__ */ new Date()).getTime(), this.step = T.INIT, this.finals = [T.LOADED, T.ERROR];
  }
  get state() {
    return this.step;
  }
  updateState(t) {
    t && t instanceof B ? this.finals.includes(this.step) || (this.step = t) : console.warn("invalid parameter type for function StateLoader.updateState()");
  }
}
const ke = () => {
  window.GTMStateLoader || (window.GTMStateLoader = new pt(), he("## GTM State Loader - dont found GTMStateLoader in window - create a new one", window.GTMStateLoader.state));
}, U = {
  getState: () => (ke(), window.GTMStateLoader.state),
  updateState: (e) => {
    ke(), window.GTMStateLoader.updateState(e);
  }
};
class ht {
  constructor() {
    this.pendingPromises = [];
  }
  isGTMReady() {
    const t = U.getState();
    return new Promise((a, n) => {
      switch (t) {
        case T.INIT:
          this.pendingPromises.push({
            resolve: a,
            reject: n
          });
          break;
        case T.LOADING:
          this.pendingPromises.push({
            resolve: a,
            reject: n
          });
          break;
        case T.LOADED:
          a(!0);
          break;
        default:
          n(t);
          break;
      }
    });
  }
  loadGTM(t, a) {
    if (document.querySelector("script#gtm-script") == null) {
      U.updateState(T.LOADING);
      const n = Q();
      ft(n).then((r) => {
        U.updateState(T.LOADED), t && typeof t == "function" && t(r);
      }).catch((r) => {
        U.updateState(T.ERROR), a && typeof a == "function" && a(r);
      }).finally(() => {
        const r = U.getState();
        he(`## Tagmanager - Loading GTM - finally - ${r} - processing pending promises`, this.pendingPromises.length), this.pendingPromises.map((o) => {
          r.equals(T.LOADED) ? o.resolve(!0) : o.reject(r);
        }), this.pendingPromises.length = 0;
      });
    } else
      console.warn("## Tagmanager - GTM script already loaded");
  }
}
let ge = window.Xloader;
window.Xloader || (ge = new ht(), window.Xloader = ge);
const ye = ge;
window.dataLayer = window.dataLayer || [];
function ce(e, t) {
  const a = Q(), n = (u, d, i = !0) => {
    if (u == a) {
      const c = b.get(Ne);
      if (c && c.endsWith(Me)) {
        const { datasList: m, isRememberMe: l } = yt(c);
        m.forEach((p) => {
          $(p);
        });
        const f = c.substring(0, c.indexOf(Me)), h = {
          domain: "." + K().rootHostname,
          path: "/"
        };
        l && (h.expires = 365), b.set(Ne, f, h);
      }
      t && typeof t == "function" && t();
    }
  }, r = fe(), o = pe(), s = Object.assign({}, A, r, o, e, {
    eventCallback: n,
    eventTimeout: 2e3
  });
  ye.isGTMReady().then(() => {
    $(s);
  }).catch(() => {
    n(a, null, !1);
  });
}
function He(e, t) {
  const a = t != null && typeof t == "function", n = Q();
  let r = e, o;
  return a && (o = (s, u, d = !0) => {
    s == n && t && typeof t == "function" && t(e);
  }, r = Object.assign({}, e, {
    eventCallback: o,
    eventTimeout: 2e3
  })), ye.isGTMReady().then(() => {
    typeof dataLayer.find((s) => s.event_data) < "u" && (r == null ? void 0 : r.event) === "GA4event" && typeof (r == null ? void 0 : r.event_data) < "u" && $({ event_data: null }), $(r);
  }).catch(() => {
    a && o(n, null, !1);
  }), e;
}
function $(e) {
  e && typeof e == "object" && Object.getOwnPropertyNames(e).length != 0 && window.dataLayer.push(e);
}
function yt(e) {
  var a, n, r;
  const t = {
    datasList: [],
    isRememberMe: !1
  };
  if (e && e.split("_").length > 5) {
    const o = e.split("_"), s = o[1] === "TRUE", u = o[3], d = o[4], i = o[5] === "TRUE", c = o[6] && o[6] !== "LOGIN" ? o[6] : "other";
    switch (u) {
      case "AUTHENTICATION":
        t.datasList.push({
          event: "GAevent",
          eventCategory: "authentication",
          eventAction: "sign in - click on cta",
          eventLabel: "connect"
        }), t.datasList.push({
          event: "GA4event",
          eventName: "authentification_interact",
          event_data: {
            pagename: (a = window == null ? void 0 : window.dataLayer.find((m) => m.dynamic_datas_ready && m.pagename)) == null ? void 0 : a.pagename,
            form_action: d === "STANDARD" ? "log in" : `log in ${d}`,
            connexion_context: c
          }
        }), s && (t.datasList.push({
          event: "GAevent",
          eventCategory: "authentication",
          eventAction: "sign in - click on cta",
          eventLabel: "stay connected"
        }), t.isRememberMe = !0, t.datasList.push({
          event: "GA4event",
          eventName: "authentification_interact",
          event_data: {
            pagename: (n = window == null ? void 0 : window.dataLayer.find((m) => m.dynamic_datas_ready && m.pagename)) == null ? void 0 : n.pagename,
            form_action: "stay connected",
            connexion_context: c
          }
        }));
        break;
      case "REGISTRATION":
        t.datasList.push({
          event: "GAevent",
          eventCategory: "authentication",
          eventAction: "sign up - click on cta",
          eventLabel: i ? "sign up - lcah" : "sign up"
        }), t.datasList.push({
          event: "GA4event",
          eventName: "sign_up",
          event_data: {
            pagename: (r = window == null ? void 0 : window.dataLayer.find((m) => m.dynamic_datas_ready && m.pagename)) == null ? void 0 : r.pagename,
            connexion_context: c
          }
        });
        break;
      default:
        t.datasList.push({
          event: "GAevent",
          eventCategory: "authentication",
          eventAction: "error",
          eventLabel: "error - invalid auth type"
        }), console.warn("## TagManager - ORM cookie - invalid authType", u);
        break;
    }
  } else
    t.datasList.push({
      event: "GAevent",
      eventCategory: "authentication",
      eventAction: "error",
      eventLabel: "error - orm wrong format"
    }), console.warn("## TagManager - ORM cookie - wrong format", e);
  return t;
}
function fe() {
  const e = {};
  return e.event = "push_dynamic_datas", e.dynamic_datas_ready = !0, e.language = et(), e.countrymarket = rt(), e.devicetype = nt(), e.currencycode = "EUR", e.userId = dt(), e.brandcontext = it(), e.env = e.env || at(), e;
}
function pe() {
  let e = {};
  e.gacid = b.get(re) || b.get(Oe) || F, e.uamerchantid = F, e.uasourceid = F, e.tarsmerchantid = F, e.tarssourceid = F, e.gacid && !b.get(re) && (b.set(re, e.gacid, { domain: $e }), ot(Oe));
  const t = b.get(We);
  if (t && t.length >= 2) {
    const a = decodeURIComponent(escape(atob(t))), n = JSON.parse(a);
    if (n.currentmerchantid == null && n.currentsourceid == null) {
      const r = ie();
      e = oe(e, {
        uamerchantid: r,
        uasourceid: r
      });
    } else
      e = oe(e, {
        uamerchantid: n.currentmerchantid,
        uasourceid: n.currentsourceid
      });
    if (n.retainedmerchantid == null && n.retainedsourceid == null) {
      const r = ie();
      e.tarsmerchantid = r, e.tarssourceid = r;
    } else
      e.tarsmerchantid = n.retainedmerchantid, e.tarssourceid = n.retainedsourceid;
    try {
      localStorage.setItem(ne, JSON.stringify({
        tarsmerchantid: e.tarsmerchantid,
        tarssourceid: e.tarssourceid
      }));
    } catch (r) {
      console.error("## TagManager - Error while localStorage.setItem for key %s", ne, r);
    }
  } else {
    const a = ie();
    e = oe(e, {
      uamerchantid: a,
      uasourceid: a
    });
    let n = JSON.parse(localStorage.getItem(ne));
    n ? (e.tarsmerchantid = n.tarsmerchantid, e.tarssourceid = n.tarssourceid) : (e.tarsmerchantid = e.uamerchantid, e.tarssourceid = e.uasourceid);
  }
  return e = Object.assign({}, e, gt(Ze)), e;
}
var E, H, Ke, Z, L = function(e, t) {
  return { name: e, value: t === void 0 ? -1 : t, delta: 0, entries: [], id: "v2-".concat(Date.now(), "-").concat(Math.floor(8999999999999 * Math.random()) + 1e12) };
}, X = function(e, t) {
  try {
    if (PerformanceObserver.supportedEntryTypes.includes(e)) {
      if (e === "first-input" && !("PerformanceEventTiming" in self)) return;
      var a = new PerformanceObserver(function(n) {
        return n.getEntries().map(t);
      });
      return a.observe({ type: e, buffered: !0 }), a;
    }
  } catch {
  }
}, Y = function(e, t) {
  var a = function n(r) {
    r.type !== "pagehide" && document.visibilityState !== "hidden" || (e(r), t && (removeEventListener("visibilitychange", n, !0), removeEventListener("pagehide", n, !0)));
  };
  addEventListener("visibilitychange", a, !0), addEventListener("pagehide", a, !0);
}, V = function(e) {
  addEventListener("pageshow", function(t) {
    t.persisted && e(t);
  }, !0);
}, S = function(e, t, a) {
  var n;
  return function(r) {
    t.value >= 0 && (r || a) && (t.delta = t.value - (n || 0), (t.delta || n === void 0) && (n = t.value, e(t)));
  };
}, x = -1, Ge = function() {
  return document.visibilityState === "hidden" ? 0 : 1 / 0;
}, Fe = function() {
  Y(function(e) {
    var t = e.timeStamp;
    x = t;
  }, !0);
}, ve = function() {
  return x < 0 && (x = Ge(), Fe(), V(function() {
    setTimeout(function() {
      x = Ge(), Fe();
    }, 0);
  })), { get firstHiddenTime() {
    return x;
  } };
}, vt = function(e, t) {
  var a, n = ve(), r = L("FCP"), o = function(d) {
    d.name === "first-contentful-paint" && (u && u.disconnect(), d.startTime < n.firstHiddenTime && (r.value = d.startTime, r.entries.push(d), a(!0)));
  }, s = window.performance && performance.getEntriesByName && performance.getEntriesByName("first-contentful-paint")[0], u = s ? null : X("paint", o);
  (s || u) && (a = S(e, r, t), s && o(s), V(function(d) {
    r = L("FCP"), a = S(e, r, t), requestAnimationFrame(function() {
      requestAnimationFrame(function() {
        r.value = performance.now() - d.timeStamp, a(!0);
      });
    });
  }));
}, Ue = !1, se = -1, Tt = function(e, t) {
  Ue || (vt(function(i) {
    se = i.value;
  }), Ue = !0);
  var a, n = function(i) {
    se > -1 && e(i);
  }, r = L("CLS", 0), o = 0, s = [], u = function(i) {
    if (!i.hadRecentInput) {
      var c = s[0], m = s[s.length - 1];
      o && i.startTime - m.startTime < 1e3 && i.startTime - c.startTime < 5e3 ? (o += i.value, s.push(i)) : (o = i.value, s = [i]), o > r.value && (r.value = o, r.entries = s, a());
    }
  }, d = X("layout-shift", u);
  d && (a = S(n, r, t), Y(function() {
    d.takeRecords().map(u), a(!0);
  }), V(function() {
    o = 0, se = -1, r = L("CLS", 0), a = S(n, r, t);
  }));
}, j = { passive: !0, capture: !0 }, bt = /* @__PURE__ */ new Date(), Be = function(e, t) {
  E || (E = t, H = e, Ke = /* @__PURE__ */ new Date(), Ve(removeEventListener), Qe());
}, Qe = function() {
  if (H >= 0 && H < Ke - bt) {
    var e = { entryType: "first-input", name: E.type, target: E.target, cancelable: E.cancelable, startTime: E.timeStamp, processingStart: E.timeStamp + H };
    Z.forEach(function(t) {
      t(e);
    }), Z = [];
  }
}, wt = function(e) {
  if (e.cancelable) {
    var t = (e.timeStamp > 1e12 ? /* @__PURE__ */ new Date() : performance.now()) - e.timeStamp;
    e.type == "pointerdown" ? function(a, n) {
      var r = function() {
        Be(a, n), s();
      }, o = function() {
        s();
      }, s = function() {
        removeEventListener("pointerup", r, j), removeEventListener("pointercancel", o, j);
      };
      addEventListener("pointerup", r, j), addEventListener("pointercancel", o, j);
    }(t, e) : Be(t, e);
  }
}, Ve = function(e) {
  ["mousedown", "keydown", "touchstart", "pointerdown"].forEach(function(t) {
    return e(t, wt, j);
  });
}, At = function(e, t) {
  var a, n = ve(), r = L("FID"), o = function(u) {
    u.startTime < n.firstHiddenTime && (r.value = u.processingStart - u.startTime, r.entries.push(u), a(!0));
  }, s = X("first-input", o);
  a = S(e, r, t), s && Y(function() {
    s.takeRecords().map(o), s.disconnect();
  }, !0), s && V(function() {
    var u;
    r = L("FID"), a = S(e, r, t), Z = [], H = -1, E = null, Ve(addEventListener), u = o, Z.push(u), Qe();
  });
}, de = {}, Et = function(e, t) {
  var a, n = ve(), r = L("LCP"), o = function(d) {
    var i = d.startTime;
    i < n.firstHiddenTime && (r.value = i, r.entries.push(d), a());
  }, s = X("largest-contentful-paint", o);
  if (s) {
    a = S(e, r, t);
    var u = function() {
      de[r.id] || (s.takeRecords().map(o), s.disconnect(), de[r.id] = !0, a(!0));
    };
    ["keydown", "click"].forEach(function(d) {
      addEventListener(d, u, { once: !0, capture: !0 });
    }), Y(u, !0), V(function(d) {
      r = L("LCP"), a = S(e, r, t), requestAnimationFrame(function() {
        requestAnimationFrame(function() {
          r.value = performance.now() - d.timeStamp, de[r.id] = !0, a(!0);
        });
      });
    });
  }
};
function le({ name: e, delta: t, id: a, value: n }) {
  const r = {
    event: "coreWebVitals",
    webVitalsMeasurement: {
      name: e,
      id: a,
      value: Math.round(e === "CLS" ? n * 1e3 : n),
      delta: Math.round(e === "CLS" ? t * 1e3 : t)
    }
  };
  window.dataLayer.push(r);
}
function Lt() {
  Tt(le), At(le), Et(le);
}
const St = {
  init: Lt
}, _t = async () => {
  try {
    return Ct().then((e) => Promise.resolve(Dt(e)));
  } catch (e) {
    return Promise.reject(e);
  }
}, Ct = async () => {
  let e = null;
  try {
    e = await (await Ie())(
      {
        fields: "individual.uaUserId,individual.isLoyaltyMember,contactMediums.contactMedium.postalAddress.city,contactMediums.contactMedium.emailContact.email,contactMediums.contactMedium.postalAddress.countryCode,loyalty.loyaltyCards.card.cardProduct.cardCodeTARS,loyalty.subscriptionCards.card.cardProduct.cardCodeTARS,loyalty.subscriptionCards.card.cardProduct.productLabel,loyalty.balances.nbPoints,individual.individualSubscriptions.individualSubscription,loyalty.awardTypes.allTypesAwardEligibility,loyalty.awardTypes.awardType.numberOfRemainingAwards,loyalty.awardTypes.numberOfRemainingAwards,loyalty.awardTypes.awardType.type,loyalty.freenights.freenight,loyalty.freenights.isEligible",
        filter: "loyalty.loyaltyCards.card:isLastActiveCard=true;loyalty.subscriptionCards.card:isLastActiveCard=true;contactMediums.contactMedium.postalAddress:isPrimary=true;,contactMediums.contactMedium.emailContact:isPrimary=true;individual.individualSubscriptions.individualSubscription:optin=true;loyalty.freenights.freenight:status=REDEEMABLE;loyalty.awardTypes.awardType:type=SNU"
      }
    );
  } catch {
    return e;
  }
  return e;
};
async function Dt(e) {
  var t, a, n, r, o, s, u, d, i, c, m, l, f, h, p, v, _, y, C, q, I, G, z, J, W, P, w, be, we, Ae, Ee, Le, Se, _e, Ce, De;
  if (e) {
    g.uilogged = !0;
    const ee = ((r = (n = (a = (t = e == null ? void 0 : e.contactMediums) == null ? void 0 : t.contactMedium) == null ? void 0 : a.find((qe) => Object.prototype.hasOwnProperty.call(qe, "emailContact"))) == null ? void 0 : n.emailContact) == null ? void 0 : r.email) || "";
    ee && ee !== "" && (g.uiemailsha256 = await je(ee)), g.userId = (o = e == null ? void 0 : e.individual) == null ? void 0 : o.uaUserId, g.uicity = ((d = (u = (s = e == null ? void 0 : e.contactMediums) == null ? void 0 : s.contactMedium[0]) == null ? void 0 : u.postalAddress) == null ? void 0 : d.city) || "", g.uicountry = ((m = (c = (i = e == null ? void 0 : e.contactMediums) == null ? void 0 : i.contactMedium[0]) == null ? void 0 : c.postalAddress) == null ? void 0 : m.countryCode) || "", g.uiallmember = (l = e == null ? void 0 : e.individual) != null && l.isLoyaltyMember ? "yes" : "no";
    const D = (h = (f = e == null ? void 0 : e.loyalty) == null ? void 0 : f.balances) == null ? void 0 : h.nbPoints;
    D >= 0 && D <= 2e3 ? g.uiloyaltypoints = "0 - 2000" : D > 2e3 && D <= 7e3 ? g.uiloyaltypoints = "2000 - 7000" : D > 7e3 && D <= 14e3 ? g.uiloyaltypoints = "7000 - 14000" : D > 14e3 && (g.uiloyaltypoints = "14000+"), ((v = (p = e == null ? void 0 : e.individual) == null ? void 0 : p.individualSubscriptions) == null ? void 0 : v.individualSubscription.length) >= 1 && (g.newsletteroptin = !0);
    const te = [], N = ((C = (y = (_ = e == null ? void 0 : e.loyalty) == null ? void 0 : _.loyaltyCards) == null ? void 0 : y.card[0]) == null ? void 0 : C.cardProduct) || null;
    N && typeof (N == null ? void 0 : N.cardCodeTARS) < "u" && te.push(N == null ? void 0 : N.cardCodeTARS);
    const R = ((G = (I = (q = e == null ? void 0 : e.loyalty) == null ? void 0 : q.subscriptionCards) == null ? void 0 : I.card[0]) == null ? void 0 : G.cardProduct) || null;
    typeof (R == null ? void 0 : R.cardCodeTARS) < "u" && te.push(R == null ? void 0 : R.cardCodeTARS), g.loyaltycardtypes = te.join(","), g.uistayplus_activation = "no stay plus", g.uisnu_activation = "no snu";
    let k = b.get("activeAwards") ? JSON.parse(b.get("activeAwards")) : null;
    ((J = (z = e == null ? void 0 : e.loyalty) == null ? void 0 : z.awardTypes) == null ? void 0 : J.allTypesAwardEligibility) === "ELIGIBLE" && ((P = (W = e == null ? void 0 : e.loyalty) == null ? void 0 : W.awardTypes) != null && P.awardType.length) && ((we = (be = (w = e == null ? void 0 : e.loyalty) == null ? void 0 : w.awardTypes) == null ? void 0 : be.awardType[0]) == null ? void 0 : we.numberOfRemainingAwards) > 0 && ((Le = (Ee = (Ae = e == null ? void 0 : e.loyalty) == null ? void 0 : Ae.awardTypes) == null ? void 0 : Ee.awardType[0]) == null ? void 0 : Le.type) === "SNU" && (g.uisnu_activation = !1, k && DEFAULT_USER_DATAect.keys(k).length && k.snu && (g.uisnu_activation = !0)), ((_e = (Se = e == null ? void 0 : e.loyalty) == null ? void 0 : Se.freenights) == null ? void 0 : _e.freenight.length) > 0 && ((De = (Ce = e == null ? void 0 : e.loyalty) == null ? void 0 : Ce.freenights) != null && De.isEligible) && (g.uistayplus_activation = !1, k && DEFAULT_USER_DATAect.keys(k).length && k.stayplus && (g.uistayplus_activation = !0)), ct(e) && (g.clienttype = "B2B");
  }
  return g;
}
function xe(e, t, a) {
  var d;
  let n = t && typeof t == "object" ? t : {};
  const r = a && typeof a == "function" ? a : null;
  let o = document.location.pathname;
  document.body && document.body.getAttribute(ae) && document.body.getAttribute(ae).length > 0 && (o = document.body.getAttribute(ae)), e && typeof e == "string" && e.length > 0 && (o = e), n.pagename && typeof n.pagename == "string" && n.pagename.length > 0 && (o = n.pagename), "page_data" in n ? n = { page_data: { ...Object.assign(n.page_data, A, fe(), pe()) } } : n = { page_data: { ...Object.assign(A, fe(), pe(), n, { pagename: o }) } };
  let s = { user_data: g };
  (d = n == null ? void 0 : n.page_data) != null && d.user_data && (s = { user_data: n.page_data.user_data }, delete n.page_data.user_data);
  let u = Object.assign({}, A, s, n, { pagename: o });
  return st() ? ce(u, r) : _t().then((i) => {
    const c = { user_data: i };
    return n.page_data.clienttype = i.clienttype || A.clienttype, u = Object.assign({}, A, i, c, n, { pagename: o }), ce(u, r);
  }).catch(() => ce(u, r));
}
function ue(e, t) {
  if (e && typeof e == "object" && Object.getOwnPropertyNames(e).length != 0) {
    const a = t && typeof t == "function" ? t : null;
    return He(Object.assign({}, e), a);
  } else
    return console.warn("## Tagmanager - Datas event must be an object not null and not empty"), !1;
}
function Nt(e, t) {
  return e && typeof e == "object" && Object.getOwnPropertyNames(e).length != 0 ? He(e, t && typeof t == "function" ? t : null) : (console.warn("## Tagmanager - Datas event must be an object not null and not empty"), !1);
}
function Mt(e) {
  Te.registerConfigurationEventTracking(e);
}
function Ot() {
  ye.loadGTM(function() {
    mt().then(function(e) {
      e && Te.trackPage(), St.init();
    });
  }, function() {
    console.error("## TagManager - callback error on load script");
  });
}
const Te = {
  getDefaultDatasEvent: () => ze,
  getDefaultDatasPage: () => A,
  trackEvent: ue,
  trackPage: xe,
  trackCheckout: Nt,
  initEventTrackingListener: Mt,
  initDefaultAutoTracking: Ot,
  // DEPRECATED METHODS
  registerConfigurationEventTracking: (e, t = !1) => {
    console.warn("## Tagmanager - deprecated method - isManualPush"), M.registerConfigurationEventTracking(e, t);
  },
  isManualPush: () => (console.warn("## Tagmanager - deprecated method - isManualPush"), me()),
  getDefaultObj: () => (console.warn("## Tagmanager - deprecated method - use getDefaultDatasPage() instead of"), A),
  _setPageName: () => {
    console.warn("## Tagmanager - deprecated method - define the pagename on body attribute data-pagename or in method trackPage(pagename,data)");
  },
  _pushData: (e) => {
    console.warn("## Tagmanager - deprecated method - use trackPage(pagename, data) instead of"), xe("", e);
  },
  _pushVirtualPageView: () => {
    console.warn("## Tagmanager - deprecated method - remove call to function _pushVirtualPageView");
  },
  pushDataCustom: (e) => (console.warn("## Tagmanager - deprecated method - use trackEvent(data, callback) instead of"), ue(e)),
  tagsPushDataCustom: (e, t) => {
    console.warn("## Tagmanager - deprecated method - use trackEvent(data, callback) instead of");
    let a = t && t.cb ? t.cb : t;
    return ue(e, a);
  },
  fillDatasFromFidelityCards: (e, t, a) => (console.warn("## Tagmanager - deprecated method - fillDatasFromFidelityCards"), M.fillDatasFromFidelityCards(e, t, a)),
  fillDatasFromPeriod: (e, t) => (console.warn("## Tagmanager - deprecated method - fillDatasFromPeriod"), M.fillDatasFromPeriod(e, t)),
  fillDatasFromRoomCriteria: (e, t) => (console.warn("## Tagmanager - deprecated method - fillDatasFromRoomCriteria"), M.fillDatasFromRoomCriteria(e, t)),
  removeNull: function() {
    console.warn("## Tagmanager - deprecated method - removeNull");
  },
  hashCode: async function(e) {
    return await je(e);
  }
};
window.TagManager = Te;
export {
  Te as T
};
//# sourceMappingURL=index-phH08dZT.js.map
